import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';
import styled from 'styled-components';

export const Container = styled.div<{ marginTop?: number }>`
  display: none;
  flex-direction: column;
  gap: 32px;
  margin-top: ${({ marginTop }) => marginTop && `${marginTop}px`};
  @media (${MEDIA_QUERIES.laptopL}) {
    display: flex;
  }
`;

export const StickyContainer = styled.div`
  position: sticky;
  top: 16px;
  display: flex;
  flex-direction: column;
  grid-gap: 32px;
  @media (${MEDIA_QUERIES.laptopL}) {
    gap: 8px;
  }
  @media (${MEDIA_QUERIES.desktopL}) {
    gap: 16px;
  }
`;
